import { useEffect, useState } from "react";
import axios from "axios";
import { Plus, Minus } from "lucide-react";
import Reveal from "@/components/landing/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    axios.get(`${API}/faqs`).then((r) => setFaqs(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (faqs.length === 0) return;
    const data = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.question,
        acceptedAnswer: { "@type": "Answer", text: f.answer },
      })),
    };
    let el = document.getElementById("faq-jsonld");
    if (!el) {
      el = document.createElement("script");
      el.id = "faq-jsonld";
      el.type = "application/ld+json";
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const e = document.getElementById("faq-jsonld");
      if (e) e.remove();
    };
  }, [faqs]);

  if (faqs.length === 0) return null;

  return (
    <section id="faq" data-testid="faq-section" className="border-b border-white/10">
      <div className="px-6 py-20 lg:px-16 lg:py-28">
        <Reveal>
          <p className="font-tac text-xs tracking-[0.3em] text-[#F5B301]">FRAGEN & ANTWORTEN</p>
          <h2 className="mt-6 max-w-4xl font-display text-4xl font-black uppercase leading-[0.9] tracking-tighter sm:text-5xl lg:text-7xl">
            Häufige <span className="text-stroke">Fragen.</span>
          </h2>
        </Reveal>

        <div className="mt-14 max-w-4xl border-t border-white/10">
          {faqs.map((f, i) => {
            const isOpen = open === f.id;
            return (
              <Reveal key={f.id} delay={i * 0.05}>
                <div className="border-b border-white/10" data-testid={`faq-${f.id}`}>
                  <button
                    data-testid={`faq-toggle-${f.id}`}
                    onClick={() => setOpen(isOpen ? null : f.id)}
                    className="group flex w-full items-center justify-between gap-6 py-6 text-left"
                  >
                    <span className={`font-display text-xl font-black uppercase tracking-tight transition-colors duration-300 lg:text-2xl ${isOpen ? "text-[#F5B301]" : "text-white group-hover:text-[#F5B301]"}`}>
                      {f.question}
                    </span>
                    <span className={`flex h-9 w-9 shrink-0 items-center justify-center border transition-colors duration-300 ${isOpen ? "border-[#F5B301] text-[#F5B301]" : "border-white/25 text-white/60 group-hover:border-[#F5B301]"}`}>
                      {isOpen ? <Minus className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
                    </span>
                  </button>
                  <div className={`grid overflow-hidden transition-all duration-500 ease-out ${isOpen ? "grid-rows-[1fr] pb-6 opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                    <div className="overflow-hidden">
                      <p className="max-w-2xl font-tac text-sm leading-relaxed text-[#A1A1AA]">{f.answer}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
